import { walletConstants , tickerConstants } from '../_constants';
import { walletService } from '../_services';
import { alertActions } from './';
import { store } from '../_helpers/store';

export const walletAction = {
    getMemberWallet , getTicker
}

function getMemberWallet(memberId) {

    return dispatch => {
        dispatch(request());
        let id = store.getState().authentication.user.id;
        
        walletService.getMemberWallet(id)
        .then( response => {
            if (response) {
                dispatch(success(response));
            }
        })
        .catch(error => {
            dispatch(failure(error));
            dispatch(alertActions.error(error.response));
        }) 
    };

    function request(memberid) { return { type: walletConstants.GETUSERWALLET_REQUEST, memberId } }
    function success(userwallet) { return { type: walletConstants.GETUSERWALLET_SUCCESS, userwallet } }
    function failure(error) { return { type: walletConstants.GETUSERWALLET_FAILURE, error } }
}

function getTicker(){
    return dispatch => {

        fetch("https://api.coinmarketcap.com/v1/ticker/?limit=2")
        .then(response => {
            return response.json();
        })
        .then(data => {
            dispatch(success(data));
        })
        .catch(error =>{
            dispatch(failure(error)); 
            console.log(error);
        })
    }
    
    function request() { return { type: tickerConstants.GETTICKER_REQUEST } }
    function success(tickerinfo) { return { type: tickerConstants.GETTICKER_SUCCESS, tickerinfo } }
    function failure(error) { return { type: tickerConstants.GETTICKER_FAILURE , error } }
}


// WEBPACK FOOTER //
// ./src/_actions/wallet.actions.js